// ==================== 内存缓存：会话消息列表 ====================
// 用于聊天页：SPA 内切换页面组件会被销毁，但模块级变量会保留，
// 再次进入聊天页时直接复用已显示的消息，避免向服务器重复拉取全部历史
let messageCache = { sessionId: 0, messages: [], lastId: 0 }

// 获取会话消息缓存
export const getChatMessageCache = () => messageCache

// 更新会话消息缓存
export const setChatMessageCache = (sessionId, messages, lastId) => {
  messageCache = { sessionId, messages: (messages || []).slice(), lastId }
}

// ==================== 已读位置：新消息提示 ====================
// 记录商城端已读的客服消息最大 id
// 用于 App.vue 全局轮询「收到客服新消息」提示时，避免对已看过的历史消息重复提示
const CHAT_NOTIFY_KEY = 'chat_notify_last_msg_id'

// 获取已读消息 id
export const getChatNotifiedMsgId = () => {
  return Number(window.localStorage.getItem(CHAT_NOTIFY_KEY)) || 0
}

// 更新已读消息 id
export const setChatNotifiedMsgId = (id) => {
  if (!id) return
  const current = getChatNotifiedMsgId()
  if (id > current) {
    window.localStorage.setItem(CHAT_NOTIFY_KEY, String(id))
  }
}

